import { http, tokenStorage } from '@shared/api';

export async function logout(): Promise<void> {
  const refreshToken = tokenStorage.getRefresh();
  if (!refreshToken) return;
  try {
    await http.post('auth/logout', { json: { refreshToken } });
  } catch {
    /* ignore — we clear local state regardless */
  }
}
